module.exports = __webpack_public_path__ + "static/img/bcg.115cd353.webp";